import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MultiSelectComponent } from './multiselect.component';
import { ClickOutsideDirective} from './click-outside.directive';
import { ListFilterPipe } from './list-filter.pipe';
import { AutoFocusDirective } from './auto-focus.directive';
import {TranslateModule} from "@ngx-translate/core";


@NgModule({
  imports: [CommonModule, FormsModule, TranslateModule],
  declarations: [MultiSelectComponent, ClickOutsideDirective, ListFilterPipe, AutoFocusDirective ],
  providers: [ListFilterPipe],
  exports: [MultiSelectComponent, ClickOutsideDirective]
})

export class NgMultiSelectDropDownModule {
    static forRoot(): ModuleWithProviders<NgMultiSelectDropDownModule> {
      return {
        ngModule: NgMultiSelectDropDownModule
      };
    }
}
